import React from 'react';
import { ContentList, ContentListItem } from '../ContentList';
import { UserMembershipEditable } from './partials/UserMembershipEditable';
import { UserMembership } from './partials/UserMembership';
import { UserMembershipDefault, UserMembershipEdit } from './UserMembershipTypes';

type UserMembershipsContentList = {
  memberships: UserMembershipDefault[] | UserMembershipEdit[];
  hierarchy?: number;
};

const isUserMembershipEdit = (
  membership: UserMembershipEdit | UserMembershipDefault,
): membership is UserMembershipEdit => membership.roles.some(role => 'editForm' in role);

export function UserMembershipsContentList({ memberships, hierarchy = 3 }: UserMembershipsContentList) {
  return (
    <ContentList>
      {memberships?.map(membership => (
        <ContentListItem key={membership.pageLink.url}>
          {isUserMembershipEdit(membership)
            ? (
                <UserMembershipEditable {...membership} hierarchy={hierarchy} />
              )
            : (
                <UserMembership {...membership} hierarchy={hierarchy} />
              )}
        </ContentListItem>
      ))}
    </ContentList>
  );
}
